<template>
  <div>
    <div v-if="isVisible" class="modal-container-bg" @click="$emit('closeModal')"></div>

    <div class="modal-container" v-if="isVisible">
      <div class="modal-container__top-bar">
        <span>{{ title }}</span>
        <button class="btn-icon" @click="() => $emit('closeModal')" title="Zamknij">
          <img src="@/assets/icons/x.svg" alt="zamknij">
        </button>
      </div>

      <form @submit="(e) => sendData(e)">
        <div :key="index" v-for="(field, index) in fields" class="field-row">
          <label :for="field.name">{{ field.label }}</label>

          <input
              v-if="field.tag == 'input'"
              :type="field.type"
              :name="field.name"
              :id="field.name"
              :placeholder="field.placeholder"
              :ref="field.name"
              :minlength="field.minlength"
              :maxlength="field.maxlength"
              :required="field.req"
              accept="image/png, image/jpeg"
              :value="field.value"
              :pattern="field.htmlPattern"
          >

          <textarea
              v-if="field.tag == 'ta'"
              :name="field.name"
              :id="field.name"
              :placeholder="field.placeholder"
              :ref="field.name"
              :required="field.req"
              :minlength="field.minlength"
              :maxlength="field.maxlength"
              :value="field.value"
          ></textarea>

          <select
              v-if="field.tag == 'select'"
              :name="field.name"
              :id="field.name"
              :ref="field.name"
              v-model="field.value"
          >
            <option :value="item.value" :key="item.value" v-for="item in field.options">
              {{ item.name }}
            </option>
          </select>
        </div>

        <div class="form-actions">
          <button type="button" class="btn-outline" @click="$emit('closeModal')">Anuluj</button>
          <button type="submit" class="btn-primary">{{ buttonText }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalVue',
  props: ['fields', 'title', 'buttonText', 'isVisible', 'itemId'],
  methods: {
    sendData(e) {
      e.preventDefault();
      const data = {};

      Object.keys(this.$refs).forEach(item => {
        if (item == 'photo') {
          data[item] = this.$refs[item][0].files[0];
        } else {
          data[item] = this.$refs[item][0].value;
        }
      });

      data.id = this.itemId;
      this.$emit('sendData', data);

      setTimeout(() => {
        this.$emit('closeModal');
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.modal-container-bg {
  position: fixed;
  inset: 0;
  background-color: rgba(17, 24, 39, 0.65);
  backdrop-filter: blur(2px);
  z-index: 40;
}

.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 24px);
  max-width: 640px;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.18);
  z-index: 50;
  overflow: hidden;

  &__top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e7eb;
    padding: 14px 16px;
    background: #f9fafb;

    span {
      color: #1f2937;
      font-size: 1.9rem;
      font-weight: 700;
      margin-right: 8px;
      word-break: break-word;
    }
  }

  form {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: min(70vh, 640px);
    overflow-y: auto;
  }
}

.field-row {
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 1.4rem;
    font-weight: 600;
    color: #374151;
  }

  input,
  textarea,
  select {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 1.4rem;
    color: #1f2937;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    box-sizing: border-box;
    width: 100%;
    background: #fff;
  }

  input:focus,
  textarea:focus,
  select:focus {
    border-color: #10b981;
    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
  }

  textarea {
    resize: vertical;
    min-height: 100px;
  }
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

@media (max-width: 480px) {
  .modal-container {
    border-radius: 8px;

    &__top-bar {
      padding: 12px;

      span {
        font-size: 1.7rem;
      }
    }

    form {
      padding: 12px;
      max-height: 75vh;
    }
  }

  .form-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>